

import React from 'react';
import { AlertWrapper } from '../UI/styledConstants';
import { isEmpty } from '../../utils/common';
import Input from '../UIbox/Input';


const transactionTypeList = [
    { value: 'Withdrawal', label: 'Withdrawal' },
    // { value: 'AP', label: 'Aadhar Pay' },
];

function TransactionScreen({controls,onChangeHandler,filterBankList,setDropdown,dropDown,message,setMessage,onSubmitHandler,searchKey,handleFilter,setAepsStatus =() =>{}}){
    

	return(
    <div className="tab-content-left">
<h2 className='flex justify-between'><span>Aadharpay Transaction</span>
	<span className='cursor tooltip' tooltip-data='Select Device' onClick={() =>setAepsStatus("selectDeviceForTransaction")}>
		<i className="fa-solid fa-caret-down"></i>
		</span>
	</h2>

	
	<Input type="text" name="transactionType" value={controls.transactionType} disabled={true} label="transactionType" onChange={()=>{}} />
	

	<Input type="text" name="aadharNumber" value={controls.aadharNumber} label="Aadhaar No." maxLength={12} inputMode="numeric" onChange={onChangeHandler} />


<Input type="text" name="mobileNumber" value={controls.mobileNumber} label="Mobile No." maxLength={10} inputMode="numeric" onChange={onChangeHandler} />
	<Input type="text" name="amount" value={controls.amount} label="Amount" inputMode="numeric" onChange={onChangeHandler} />
	

	<div className="form-field form-field-select-bank">
		<div className="form-field searchBank">
		<Input
				type="text"
				className="search"
				name="amount"
				style={{ marginBottom: '0' }}
				label="Search Bank..."
				value={searchKey}
				onChange={handleFilter}
				onFocus={(e) => setDropdown(true)}
			/>
		</div>
		{dropDown && (
			<div className="radio-group" style={{ backgroundColor: '#fff' }}>
				{filterBankList &&
					filterBankList.map((val, index) => {
						return (
							<label key={index} className={controls.bank === val?.iinno ? 'radio active' : 'radio'}>
								<input type="radio" name="bank" value={val?.iinno} onChange={onChangeHandler} />
								<span className="icon-with-name">{val?.bankName}</span>
							</label>
						);
					})}
			</div>
		)}
	</div>
	{!isEmpty(message) && message.place === 'form' && (
		<AlertWrapper className={message.type}>
			<span className="close" onClick={() => setMessage({})}>
				×
			</span>
			{message.msg}
		</AlertWrapper>
	)}

	<button type="submit" className="button-outline" onClick={onSubmitHandler}>
		SUBMIT
	</button>
</div>)
}

export default TransactionScreen